import { UI_CLEAR_TEAM_SETTINGS_BILLING_ERRORS } from "./teamSettingsTypes";

export const clearTeamSettingsBillingErrors = () => {
  return {
    type: UI_CLEAR_TEAM_SETTINGS_BILLING_ERRORS
  };
};
